import modalService from '~/@common/services/modal.service'
import Modal from '~/@common/ui/modal/Modal'

/**
 * 학원그룹(와이즈만 전국 수학학력평가) 시험에 학생이 IN_PROGRESS 외 상태에서
 * 진입하려 할 때 띄우는 차단 모달.
 *
 * 와이즈만은 매 시험의 문제가 동일하므로, 종료/제출 이후엔 시험지를 다시 볼 수 없다.
 * 호출처:
 * - 학습홈 카드 클릭 가드 (`studyCardNav.handleStudyCardClick`)
 * - 학습지 리스트 PC 카드 클릭 가드 (`StudentWorksheetTable.clickParentCard`)
 * - 학습지 리스트 모바일 카드 클릭 가드 (`StudentWorksheetListMobileView.clickParentCard`)
 */
export const openAcademyGroupAccessBlockedModal = (): void => {
  modalService.openModal(
    <Modal.Alert
      confirm={{
        onClick: () => {
          modalService.closeModal()
        },
      }}
    >
      학생앱에서는 시험종료 후
      <br />
      시험지를 확인할 수 없습니다.
    </Modal.Alert>,
    { modalName: 'ACADEMY_GROUP 시험 접근 제한 모달' },
  )
}
